var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-approve.fd27e9a4.png","uri@2x": __webpack_public_path__ + "icon-approve.8be20ced.png","uri@3x": __webpack_public_path__ + "icon-approve.1f2de16d.png",
    width: 41,
    height: 40
});